import { useNavigate } from "react-router-dom";
import { SmartSoftButton } from "soft_digi";


const Header = () => {
  const navigate = useNavigate()
  return (
    <div className="navbar smart-pdf-nav">
      <div className="navbar-start"></div>
      <div className="navbar-end">
        <div className="navbar-item">
          <SmartSoftButton label="LOGIN" classList={["button is-small btn2"]} onClick={()=>navigate("/login")}/>
        </div>
      </div>
    </div>
  );
};

export default Header;

/*  
 <a className="navbar-content has-text-white smart-pdf-site-title">
          Soft Digi Solutions
        </a>
*/
